import { Pipe, PipeTransform } from '@angular/core';
import { MwUtils } from '@core/utils';

@Pipe({ name: 'mwFilter' })
export class MwFilterPipe implements PipeTransform {
  transform(mainArr: any[], searchText: string, property: string): any[] {
    if (typeof searchText === 'string') {
      return MwUtils.filterArrayByString(mainArr, searchText, property);
    } else {
      return mainArr;
    }
  }
}
